import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

const stripHtml = (value) => {
  if (!value || typeof value !== "string") return value ?? "-";

  return value
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n\n")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .trim() || "-";
};

function ReadOnlyField({ label, value, multiline = false }) {
  const displayValue = multiline ? stripHtml(value) : (value ?? "-");

  return (
    <Grid item xs={12}>
      <MDTypography component="label" variant="button" fontWeight="regular" color="text">
        {label}
      </MDTypography>
      <MDInput
        fullWidth
        variant="standard"
        value={displayValue}
        multiline={multiline}
        rows={multiline ? 4 : undefined}
        InputProps={{ readOnly: true }}
      />
    </Grid>
  );
}

function ScenarioViewForm({ value, onBack, onEdit }) {
  const { t } = useTranslation();
  return (
    <MDBox component="form" pb={3} px={3} onSubmit={(e) => e.preventDefault()}>
      <Grid container spacing={3}>
        <ReadOnlyField label={t("scenarios.view.fields.scenarioId")} value={value.scenario_id} />
        <ReadOnlyField label={t("scenarios.view.fields.category")} value={value.category} />
        <ReadOnlyField label={t("scenarios.view.fields.scenarioName")} value={value.name} />
        <ReadOnlyField label={t("scenarios.view.fields.description")} value={value.description} multiline />
        <ReadOnlyField label={t("scenarios.view.fields.startDate")} value={value.start_date} />
        <ReadOnlyField label={t("scenarios.view.fields.endDate")} value={value.end_date} />
        <ReadOnlyField label={t("scenarios.view.fields.kpi")} value={value.kpi} />
        <ReadOnlyField label={t("scenarios.view.fields.kpiOption")} value={value.kpi_option} />
        <ReadOnlyField label={t("scenarios.view.fields.kpiMonitoringIds")} value={value.kpi_monitoring_ids} />
        <ReadOnlyField label={t("scenarios.view.fields.action")} value={value.action} />
        <ReadOnlyField label={t("scenarios.view.fields.targets")} value={value.targets} />
        <ReadOnlyField label={t("scenarios.view.fields.typeIds")} value={value.type_ids} />
        <ReadOnlyField label={t("scenarios.view.fields.locationType")} value={value.location_type} />
        <ReadOnlyField label={t("scenarios.view.fields.locationPathIds")} value={value.location_path_ids} />
        <ReadOnlyField label={t("scenarios.view.fields.message")} value={value.message} multiline />
        <ReadOnlyField label={t("scenarios.view.fields.createdBy")} value={value.created_by} />

        <Grid item xs={12}>
          <MDBox mt={2} display="flex" justifyContent="flex-start">
            <MDButton variant="gradient" color="info" onClick={onEdit} sx={{ mr: 2 }}>
              {t("common.buttons.edit")}
            </MDButton>
            <MDButton variant="outlined" color="info" onClick={onBack}>
              {t("scenarios.view.backToLibrary")}
            </MDButton>
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default ScenarioViewForm;
